import { useState } from 'react';

export const useHasChanged = <T>(value: T): [boolean, T] => {
  const [prevValue, setPrevValue] = useState(value);

  if (prevValue !== value) {
    setPrevValue(value);
  }
  return [prevValue !== value, prevValue];
};
